import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Modal,
} from "@mui/material";
import { ArrowDropDown, DeleteOutline, Search } from "@mui/icons-material";
// import { serverUrl } from '../server';
import CloseIcon from "@mui/icons-material/Close";
import { getRequest, patchRequest, server } from "../config";
import moment from "moment";
import axios from "axios";
import PartnerProfile from "../components/PartnerProfile";

const WithdrawalRequest = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCity, setSelectedCity] = useState("");
  const [allCities, setallCities] = useState([]);
  const [backData, setbackData] = useState([]);
  const [actualValue, setactualValue] = useState({ name: "All Cities" });
  const [open, setOpen] = useState(false);
  const [filter, setfilter] = useState({});
  const [editOpen, seteditOpen] = useState(false);
  const [editedMessage, seteditedMessage] = useState("");
  const [selectedId, setselectedId] = useState({});
  const [status, setstatus] = useState("All");
  const [selectedItem, setselectedItem] = useState({});
  const [partnerPanel, setpartnerPanel] = useState(null)
  const [transactionId, setTransactionId] = useState("");
  const handleClickOpen = (id) => {
    setfilter({ subCategoryId: id?.subCategoryId, userId: id?.userId });
    setOpen(true);
  };
  useEffect(() => {
    fetchCustomers();
  }, [searchQuery, page, rowsPerPage, selectedCity, status]);
  const handleChange = (e) => {
    seteditedMessage(e.target.value);
  };
  const handleUpdate = async (id,status) => {
    try {
      const uri =
        server.uri +
        `withdrawals/${id}`;
      const body = {status:status};
      if(status === 'completed' && transactionId){
        body.transactionId = transactionId;
      }
      const updatedData = await patchRequest(uri,body);
      if (updatedData == 204) {
        setIsModalVisible(false)
        seteditOpen(false);
        setTransactionId("");
        fetchCustomers()
      }
    } catch (error) {}
  };
  const handleDelete = async () => {
    try {
      const uri =
        server.uri +
        `requests/bulk/filter?where={"subCategoryId":"${filter?.subCategoryId}","userId":"${filter?.userId}"}`;
      const deleteRequest = await axios.delete(uri);
      if (deleteRequest) {
        setOpen(false);
        await fetchCustomers();
      }
    } catch (error) {
      alert(JSON.stringify(error));
    }
  };
  // Fetch customers from the LoopBack backend with filter and pagination

  const fetchCustomers = async () => {
    try {
      const filter = {
        where: {
          or: [
            { name: { like: `%${searchQuery}%` } },
            { email: { like: `%${searchQuery}%` } },
            { pincode: { like: `%${searchQuery}%` } },
          ],
        },
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      };

      const response = await getRequest(
        `${server.uri}withdrawals?filter={
        "skip":"${filter.skip}",
        "where":${status == "All" ? "{}" : `{"status":"${status}"}`},
        "order":"createdAt desc","include":[{"relation":"user"},{"relation":"accountDetails"}]}`
      );
      //   console.log(response);

      setCustomers(response);
      const responseCount = await getRequest(
        `${server.uri}withdrawals/count?where=${
          status == "All" ? "{}" : `{"status":"${status}"}`
        }`
      );

      // console.log(responseCount);
      setTotalCount(responseCount?.count);
      // setTotalCount(responseCount.count);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // Handle search query change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when search changes
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleCityChange = (event, value) => {
    setSelectedCity(value?.name);
    setactualValue(value);
    setPage(0); // Reset to the first page when city changes
  };

  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"]; // Example city list
  if(partnerPanel){
    return(<PartnerProfile partner={partnerPanel} onClose={()=>setpartnerPanel(null)}/>)
  }
  return (
    <Container>
      <Modal
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        aria-labelledby="modal-title"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxHeight: "900px",
        }}
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <div
            onClick={() => setIsModalVisible(false)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              cursor: "pointer",
            }}
          >
            <Typography id="modal-title" variant="h4" component="h2">
              Withdrawal Request
            </Typography>
            <CloseIcon />
          </div>
          <table style={{ marginTop: 20, marginBottom: 20 }}>
            <tr>
              <td>
                {" "}
                <strong>Partner Name:</strong>{" "}
              </td>
              <td>{selectedItem?.user?.name}</td>
            </tr>
            <tr>
              <td>
                {" "}
                <strong>Mobile Number</strong>{" "}
              </td>
              <td>{selectedItem?.user?.mobileNumber}</td>
            </tr>
            <tr>
              <td>
                {" "}
                <strong>City</strong>{" "}
              </td>
              <td>{selectedItem?.user?.city}</td>
            </tr>
          </table>
          <Typography variant="h5" sx={{ mt: 2, mb: 2 }}>
           Bank Account Details
          </Typography>
          <table style={{ marginTop: 20, marginBottom: 20 }}>
            <tr>
              <td>
                {" "}
                <strong>Account Name:</strong>{" "}
              </td>
              <td>{selectedItem?.accountDetails?.accountName}</td>
            </tr>
            <tr>
              <td>
                {" "}
                <strong>Account Number</strong>{" "}
              </td>
              <td>{selectedItem?.accountDetails?.accountNumber}</td>
            </tr>
            <tr>
              <td>
                {" "}
                <strong>IFSC Code</strong>{" "}
              </td>
              <td>{selectedItem?.accountDetails?.bankIFSC}</td>
            </tr>
          </table>
         {selectedItem?.status==='pending'&& <>
           <TextField
             fullWidth
             variant="outlined"
             label="Transaction ID"
             value={transactionId}
             onChange={(e) => setTransactionId(e.target.value)}
             sx={{ mt: 2 }}
             placeholder="Enter transaction ID to approve"
           />
           <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                          <Button variant="outlined" onClick={()=>handleUpdate(selectedItem?.withdrawalId,'rejected')} sx={{ mr: 2 }}>
                            Reject 
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={()=>handleUpdate(selectedItem?.withdrawalId,'completed')}
                            disabled={!transactionId}
                            // onClick={() => ap(selectedPartner?.userId,'verified')}
                          >
                            Mark As Completed
                          </Button>
                        </Box>
           </>}
        </Box>

      </Modal>
      <Typography variant="h4" sx={{ marginTop: 8, marginBottom: 2 }}>
        Withdrawal Request List
      </Typography>
      
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete Service"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are You Sure to Delete Service?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => handleDelete(filter)}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={editOpen} onClose={() => seteditOpen(false)}>
        <DialogTitle>Edit Message</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            variant="outlined"
            label="Message"
            value={editedMessage}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => seteditOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleUpdate} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Search Bar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        {/* <TextField
          variant="outlined"
          placeholder="Search by name/mobile number/pincode"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        /> */}

        <FormControl variant="outlined" sx={{ minWidth: 200 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginRight: 2,
            }}
          >
            <TextField
              select
              label="Filter by Status"
              value={status}
              onChange={(e) => setstatus(e.target.value)}
              fullWidth
            >
              {[
                { value: "All", label: "All" },
                { value: "pending", label: "Pending" },
                { value: "completed", label: "Completed" },
                { value: "rejected", label: "Rejected" },
              ].map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

            {/* Specific Date Input (Visible only for "Specific Date" filter) */}
          </Box>
        </FormControl>
      </Box>
      <Typography variant="subtitle1" sx={{ textAlign: "right" }} gutterBottom>
        Total Requests: <strong>{customers?.length}</strong>
      </Typography>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f4f6f8", // Light background for table header
                }}
              >
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>

                <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>

                <TableCell sx={{ fontWeight: "bold" }}>
                  Withdrawal Amount
                </TableCell>

                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Requested At</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers?.map((customer) => (
                <TableRow
                  sx={{
                    "&:nth-of-type(even)": {
                      backgroundColor: "#f9fafb", // Alternate row color for better readability
                    },
                  }}
                  key={customer.userId}
                >
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setpartnerPanel(customer)
                      // setIsModalVisible(true);
                      // setselectedItem(customer);
                    }}
                  >
                    {customer?.user?.name}
                  </TableCell>

                  <TableCell>{customer?.user?.mobileNumber}</TableCell>
                  <TableCell>{customer?.user?.city}</TableCell>

                  <TableCell>₹{customer?.amount}</TableCell>
                  <TableCell sx={{}}>{customer?.status}</TableCell>
                  <TableCell>
                    {moment(customer?.createdAt).startOf("hour").fromNow()}
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        setselectedItem(customer);
                        setTransactionId("");
                        setIsModalVisible(true);
                      }}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Container>
  );
};

export default WithdrawalRequest;
